import { useState, useCallback } from "react";
import { addDayMarkerApi, deleteDayMarkerApi } from "../services/dashboardService";

export function useDayMarkers({ workspaceId, token }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const addMarker = useCallback(async ({ date, color, label }) => {
        setLoading(true);
        setError(null);
        try {
            await addDayMarkerApi({ workspaceId, date, color, label, token });
        } catch (err) {
            setError(err);
            console.error(err);
            throw err;
        } finally {
            setLoading(false);
        }
    }, [workspaceId, token]);

    const deleteMarker = useCallback(async (date) => {
        setLoading(true);
        setError(null);
        try {
            await deleteDayMarkerApi({ workspaceId, date, token });
        } catch (err) {
            setError(err);
            console.error(err);
            throw err;
        } finally {
            setLoading(false);
        }
    }, [workspaceId, token]);

    return { addMarker, deleteMarker, loading, error };
}
